import { Component, Input } from '@angular/core';
import { Measure } from '@common/pipe/unit-measurement';
import { TranslatePipe } from '@ngx-translate/core';
import { UnitTypeIconComponent } from '@shared/components/unit-type-icon/unit-type-icon.component';
import { MoneyFormatPipe } from '@common/pipe/money-format.pipe';
import { UnitTypeDirective } from '@common/directive/unit-type.directive';
import { UnitTypesInterface } from '@modules/settings/unit-types/unit-types.interface';
import { NgStyle } from '@angular/common';
import { FigmaIconComponent } from '@shared/components/figma-icon/figma-icon.component';

@Component({
  selector: 'utility-rate-card',
  standalone: true,
  imports: [
    Measure,
    TranslatePipe,
    UnitTypeIconComponent,
    MoneyFormatPipe,
    UnitTypeDirective,
    NgStyle,
    FigmaIconComponent
  ],
  templateUrl: './utility-rate-card.component.html',
  styleUrl: './utility-rate-card.component.scss'
})
export class UtilityRateCardComponent {
  @Input() data: any;
  unitType: UnitTypesInterface;
  color: string;

  ngOnInit(): void {
    this.unitType = this.data?.unitType;
    if (this.unitType && this.unitType.color) {
      this.color = this.HEXtoRGB(this.unitType.color);
    }
  }
  HEXtoRGB(hex: string): string {
    let hexValue = parseInt(hex.indexOf('#') > -1 ? hex.substring(1) : hex, 16);
    return [hexValue >> 16, (hexValue & 0x00ff00) >> 8, hexValue & 0x0000ff].join(',');
  }
}
